import { payPalLocaleOfZppLocale } from '../types-internal/PayPalTypes.js';

/**
 * Convert ZPP locale to the PayPal supported locale.
 *
 * @param zppLocale The ZPP locale that need to be converted
 */
const convertZppLocaleToPayPalLocale = (zppLocale) => {
    // The fallback locale is "en_GB"
    return payPalLocaleOfZppLocale[zppLocale] ?? 'en_GB';
};

export { convertZppLocaleToPayPalLocale };
//# sourceMappingURL=PayPalUtils.js.map
